/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 50,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    value09: "",
    value10: "",
    value11: "",
    value12: "",
    value13: "",
    value14: "",
    value15: "",
    value16: "",
    value17: "",
  },
];

function TaxPersonalTable03({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTable2", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value09: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", background: "#f4f4f4" }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Họ và tên
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã số thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Loại giấy tờ (Số CMND/CCCD/Hộ chiếu/GKS)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số giấy tờ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Ngày sinh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Quan hệ với người nộp thuế
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Thời gian được tính giảm trừ trong năm tính thuế
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Từ tháng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Đến tháng
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [09]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [10]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [11]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [12]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [13]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [14]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [15]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [16]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [17]
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}

                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value12", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value14"
                    onChange={(e) => setFieldValue("value14", e[0])}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value15", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                    }}
                    name="value16"
                    onChange={(e) => setFieldValue("value16", e[0])}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                    }}
                    name="value17"
                    onChange={(e) => setFieldValue("value17", e[0])}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

export default memo(TaxPersonalTable03);

function InputTable(props) {
  const { onChange, type = "text", name, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, type, id });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
